import { MBView } from '@shared/components/MBView';
import { MBInlineCard } from '@shared/components/blocks/lib/cards/MBInlineCard';
import { LinkedCard } from '@shared/components/blocks/lib/cards/index';

interface Props {
  cards: LinkedCard[];
  wrapCards?: boolean;
  onPressCard?(card: LinkedCard): void;
  onRemoveCard?(card: LinkedCard): void;
  displayClearButton?: boolean;
}

export function MBInlineCardList({ cards, wrapCards, onPressCard, onRemoveCard }: Props) {
  return (
    <MBView fullWidth style={wrapCards && { flexWrap: 'wrap', flexDirection: 'row' }}>
      {cards?.map(card => (
        <MBInlineCard
          key={card.cardId}
          card={card}
          onPress={onPressCard}
          {...(onRemoveCard && { onRemove: () => onRemoveCard(card) })}
        />
      ))}
    </MBView>
  );
}
